import { render, staticRenderFns } from "./leadsPerTime.vue?vue&type=template&id=4c3b72c2"
import script from "./leadsPerTime.vue?vue&type=script&lang=js"
export * from "./leadsPerTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports